import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal.component';
import { AngularSvgIconModule } from 'angular-svg-icon';

@NgModule({
  declarations: [ModalComponent],
  exports: [ModalComponent],
  imports: [CommonModule, AngularSvgIconModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ModalModule {}
